var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 810,
    viewBox: "0 0 1440 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_2222)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 810,
    fill: "#00051D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1389_2222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M944.878 -271.878C1058.16 -158.593 1058.5 24.7468 945.622 137.622C832.747 250.497 649.408 250.164 536.122 136.878C422.836 23.5921 422.503 -159.747 535.378 -272.622C648.253 -385.497 831.592 -385.164 944.878 -271.878Z",
    fill: "#8282FF",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1389_2222",
    x: 50.9395,
    y: -757.061,
    width: 1379.12,
    height: 1379.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_1389_2222"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_2222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 810,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePage);
export default __webpack_public_path__ + "static/media/HomePage.fa075e7c0c16061eb1e9091353ee1593.svg";
export { ForwardRef as ReactComponent };